import { render, staticRenderFns } from "./fans.vue?vue&type=template&id=156d1392"
import script from "./fans.vue?vue&type=script&lang=js"
export * from "./fans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports